import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCode: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-code, sandbox"><path d="M3.75 5.75L12 2.25L20.25 5.75V13C20.25 17.5563 16.5563 21.25 12 21.25C7.44365 21.25 3.75 17.5563 3.75 13V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 9.75L7.75 12L10 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14 14.25L16.25 12L14 9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShieldCode;
